import { render, staticRenderFns } from "./CriterionOverview.vue?vue&type=template&id=29bf5d56&scoped=true"
import script from "./CriterionOverview.vue?vue&type=script&lang=js"
export * from "./CriterionOverview.vue?vue&type=script&lang=js"
import style0 from "./CriterionOverview.vue?vue&type=style&index=0&id=29bf5d56&prod&lang=css"
import style1 from "./CriterionOverview.vue?vue&type=style&index=1&id=29bf5d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf5d56",
  null
  
)

export default component.exports